import { Wifi, WifiOff, RefreshCw, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { StatusConexao } from '@/hooks/useOnlineStatus';

interface Props {
  statusConexao: StatusConexao;
  vendasPendentes: number;
  conflitos: number;
}

export function BannerConexao({ statusConexao, vendasPendentes, conflitos }: Props) {
  if (statusConexao === 'online' && conflitos === 0) return null;

  if (conflitos > 0) {
    return (
      <div className="flex items-center gap-2 bg-destructive/10 border-b border-destructive/20 px-4 py-1.5 text-xs text-destructive">
        <AlertTriangle className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="font-medium">
          {conflitos} venda{conflitos > 1 ? 's' : ''} com conflito —{' '}
          <Link to="/pdv/sincronizacao-offline" className="underline">
            revisar
          </Link>
        </span>
      </div>
    );
  }

  if (statusConexao === 'sincronizando') {
    return (
      <div className="flex items-center gap-2 bg-blue-50 border-b border-blue-200 px-4 py-1.5 text-xs text-blue-700">
        <RefreshCw className="h-3.5 w-3.5 flex-shrink-0 animate-spin" />
        <span>Sincronizando {vendasPendentes} venda{vendasPendentes > 1 ? 's' : ''} pendente{vendasPendentes > 1 ? 's' : ''}...</span>
      </div>
    );
  }

  if (statusConexao === 'offline') {
    return (
      <div className="flex animate-pulse items-center gap-2 bg-yellow-50 border-b border-yellow-300 px-4 py-1.5 text-xs text-yellow-800">
        <WifiOff className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="font-medium">Sem conexão — vendas sendo salvas localmente</span>
        {vendasPendentes > 0 && (
          <span className="ml-auto">
            {vendasPendentes} pendente{vendasPendentes > 1 ? 's' : ''}
          </span>
        )}
      </div>
    );
  }

  // online mas sem conflitos — não exibe nada (null acima já cobre)
  return (
    <div className="flex items-center gap-2 bg-green-50 border-b border-green-200 px-4 py-1 text-xs text-green-700">
      <Wifi className="h-3 w-3" />
      <span>Online</span>
    </div>
  );
}
